import Transformer from "./../transformer";

export default class AffectedTransformer extends Transformer {
  static fetch(affected) {
    const process = affected.process;
    const customer_process = affected.customer_process;
    const currency = affected.currency;

    const {
      full_documentation_date: fullDocumentationDate,
      physical_documentation_date: physicalDocumentationDate,
    } = affected;
    const fullDocumentation = !!fullDocumentationDate;
    const physicalDocumentation = !!physicalDocumentationDate;

    return {
      id: affected.id,
      yearTimes: affected.year_times_report,
      dateType: affected.date_type_report,
      changeToVaco: affected.change_vaco,
      requisitionNumber: affected.requisition_number,
      description: affected.description,
      totalAmount: affected.total_amount,
      currency,
      currencyId: currency.id,
      currencyName: currency.name,
      typeOfDamage: affected.type_of_damage,
      process: {
        ...affected.process,
        number: +affected.process.number,
      },
      customerProcessId: customer_process ? customer_process.id : null,
      processName: process.name,
      visibleForRepport: affected.visible_for_master_repport,
      fullDocumentation,
      fullDocumentationDate,
      physicalDocumentation,
      physicalDocumentationDate,
      rejectedConcepts: affected.rejected_concepts, //! DEPRECATED
      conceptRejectionDate: affected.concept_rejection_date, //! DEPRECATED
      conceptRejectionSolutionDate: affected.concept_rejection_solution_date, //! DEPRECATED

      requiredGO: affected.required_go,
      requiredBTC: affected.required_btc,
      requiredFDP: affected.required_fdp,
    };
  }

  static send(affected) {
    return {
      requisition_number: affected.requisitionNumber,
      description: affected.description,
      total_amount: affected.totalAmount,
      currency: affected.currencyId,
      type_of_damage: affected.typeOfDamage,
      change_vaco: affected.changeToVaco,
    };
  }
}



// WEBPACK FOOTER //
// ./src/transformers/sinister/affected.js